import { BrainLoadingIcon } from 'morpheus-ui';
import { Typography } from '../../molecules/Typography';

interface iLoadingPageProps {
  label: string;
}

function LoadingPage({ label }: iLoadingPageProps) {
  return (
    <div className='flex h-[calc(100vh-70px)] w-full flex-col items-center justify-center gap-md'>
      <BrainLoadingIcon className='h-32 w-32 animate-pulse stroke-brand-color-primary-pure stroke-2' />
      <Typography className='text-brand-color-primary-pure'>{label}</Typography>
    </div>
  );
}

export { LoadingPage };
